export const TESTIDS = {
  // Header
  headerLogo: "header-logo",
  navLinkAbout: "nav-link-about",
  navLinkCategories: "nav-link-categories",
  navLinkEbay: "nav-link-ebay",
  navLinkContact: "nav-link-contact",
  headerCtaEbay: "header-cta-ebay-button",
  mobileMenuToggle: "mobile-menu-toggle",

  // Hero
  heroHeadline: "hero-headline",
  heroCtaEbay: "hero-cta-ebay-button",
  heroCtaContact: "hero-cta-contact-button",

  // About
  aboutSection: "about-section",

  // Categories
  categoriesSection: "categories-section",
  categoryCard: (slug) => `category-card-${slug}`,

  // eBay Preview
  ebayPreviewSection: "ebay-preview-section",
  ebayPreviewCta: "ebay-preview-cta-button",

  // Why us
  whyUsSection: "why-us-section",

  // Contact
  contactSection: "contact-section",
  contactName: "contact-form-name",
  contactEmail: "contact-form-email",
  contactPhone: "contact-form-phone",
  contactSubject: "contact-form-subject",
  contactMessage: "contact-form-message",
  contactSubmit: "contact-form-submit-button",
  contactSuccess: "contact-form-success",
  contactError: "contact-form-error",

  // Footer
  footer: "site-footer",
  footerEbayLink: "footer-ebay-link",
  footerEmailLink: "footer-email-link",
  footerPhoneLink: "footer-phone-link",
  footerImpressumLink: "footer-impressum-link",
  footerDatenschutzLink: "footer-datenschutz-link",

  // Legal pages
  impressumPage: "impressum-page",
  datenschutzPage: "datenschutz-page",
  legalBackHome: "legal-back-home-link",
};
